"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BorrowAction = void 0;
const models_1 = require("../../models");
const refreshObligation_1 = require("./util/refreshObligation");
const larixInstructionCollector_1 = require("../../utils/larixInstructionCollector");
const baseAction_1 = require("./util/baseAction");
const account_1 = require("../../utils/account");
class BorrowAction extends baseAction_1.BaseAction {
    borrow(amount, borrowReserveData, larixObligation) {
        return __awaiter(this, void 0, void 0, function* () {
            const borrowReserve = borrowReserveData.state;
            const allReserve = this.marketData.reserveStates;
            const lendingProgramId = this.marketConfig.programId;
            let liquidityTokenAccount = this.userInfo.getLiquidityTokenAccount(borrowReserveData);
            let obligation = larixObligation === null || larixObligation === void 0 ? void 0 : larixObligation.state;
            if (obligation === undefined) {
                const myObligations = yield this.userInfo.getObligationOfMarket(this.marketConfig.marketId, lendingProgramId);
                if (myObligations.length > 0) {
                    obligation = myObligations[0];
                }
            }
            if (obligation === undefined) {
                throw new Error("Invalid obligation undefined");
            }
            const larixTransaction = new larixInstructionCollector_1.LarixInstructionCollector(this.wallet);
            const destinationLiquidityPubkey = yield (0, account_1.findOrCreateAccountByMint)(this.connection, this.userInfo.publicKey, this.userInfo.publicKey, larixTransaction.instructions, larixTransaction.cleanupInstructions, borrowReserve.info.liquidity.mintPubkey, larixTransaction.signers, liquidityTokenAccount);
            yield (0, refreshObligation_1.refreshObligation)(this.connection, this.marketConfig, larixTransaction.signers, larixTransaction.instructions, larixTransaction.cleanupInstructions, obligation, allReserve, lendingProgramId, borrowReserve);
            larixTransaction.instructions.push((0, models_1.borrowObligationLiquidityInstruction)(amount, borrowReserve.info.liquidity.supplyPubkey, destinationLiquidityPubkey, borrowReserve.pubkey, borrowReserve.info.liquidity.feeReceiver, obligation.pubkey, borrowReserve.info.lendingMarket, this.marketConfig.authorityId, obligation.info.owner, this.marketConfig.larixOracleProgramId, this.marketConfig.mineMint, this.marketConfig.mineSupply, lendingProgramId));
            return larixTransaction;
        });
    }
    ;
}
exports.BorrowAction = BorrowAction;
